import * as React from 'react';
import { SVGProps } from 'react';

const IconVideoSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2l4 2V8l-4 2V8a2 2 0 0 0-2-2H5z" />
  </svg>
);
export default IconVideoSizeM;
